import { useSelector } from 'react-redux';
import { selectUser } from './selectors';
import { useEmployee } from '../employees/employeesSlice';

export const useUser = () => {
    return useSelector(selectUser);
};

export const useUserEmployee = () => {
    const user = useUser();
    const [employee] = useEmployee(user ? user.employeeId : null);

    return { user, employee };
};

export const userHasUserEmployeeEmailAccess = (employee, email_inbox_id) => {
    //console.log('userHasUserEmployeeEmailAccess =>', employee, email_inbox_id);
    if (!employee || !email_inbox_id) {
        return false;
    }
    if (employee.emailInboxes === undefined || employee.emailInboxes === null) {
        return false;
    }

    // Check if the email receiver is in the employee's email inboxes
    const hasAccess = employee?.emailInboxes?.some((inbox) => {
        if (!inbox) 
            return false;
        return inbox?.id === email_inbox_id;
    });

    return hasAccess;
}
